<template>
  <youtube :ref="videoRef" class="youtube-wrapper" v-bind="customAttr" v-on="$listeners" />
</template>

<script>
import { getIdFromUrl, Youtube } from "vue-youtube";
export default {
    name: "YoutubeWrapper",
    components: {
        Youtube
    },
    props: {
        url: {
            type: String,
            required: true
        },
        transparent: {
            type: Boolean,
            default: true
        },
        config: {
            type: Object,
            default: () => ({
                modestbranding: true
            })
        }
    },
    computed: {
        videoRef() {
            return `video-${this.url}`;
        },
        videoId() {
            return getIdFromUrl(this.url);
        },
        customAttr() {
            return {
                "fit-parent": true,
                resize: true,
                ...this.$attrs,
                "video-id": this.videoId,
                "player-vars": this.config
            };
        }
    }
};
</script>
